import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('LeaderboardTabs').create(({ theme }) => ({
  root: {
    width: '100%',

    padding: '2px',

    display: 'flex',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    background: theme.colors.background.primary,

    paddingBottom: '12px',
  },

  tab: {
    position: 'relative',
    zIndex: '1',
    flex: 1,
    minWidth: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    padding: '3px 10px',
    cursor: 'pointer',

    span: {
      fontWeight: 450,
      fontSize: '14px',
      lineHeight: '20px',
      color: theme.colors.text.primary,
    },
  },

  activeContainer: {
    position: 'absolute',
    zIndex: 1,
    background: 'rgba(255, 255, 255, 0.16)',
    width: '100%',
    height: '32px',
    borderRadius: '8px',
  },
}))
